var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.544,
    height: 21.56,
    viewBox: "0 0 21.544 21.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-svgrepo-com",
    transform: "translate(-0.169 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80258",
    "data-name": "Path 80258",
    d: "M11.293,65.859,8.228,68.924a4.319,4.319,0,0,1-6.109-6.109L7.89,57.045a4.32,4.32,0,0,1,7.153,1.691l-2.731,2.731a1.945,1.945,0,0,1-3.178-.643.344.344,0,0,0-.638.258,2.634,2.634,0,0,0,4.3.871l5.771-5.771a2.634,2.634,0,0,0-3.725-3.725l-1.822,1.822a.344.344,0,1,0,.487.487l1.822-1.822A1.946,1.946,0,0,1,18.083,55.7l-2.5,2.5A5.008,5.008,0,0,0,7.4,56.558L1.633,62.329a5.008,5.008,0,0,0,7.082,7.082l3.065-3.065a.344.344,0,0,0-.487-.487Z",
    transform: "translate(0 -49.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80259",
    "data-name": "Path 80259",
    d: "M69.562,1.464a5.013,5.013,0,0,0-7.082,0L59.411,4.534a.344.344,0,0,0,.487.487l3.069-3.069A4.319,4.319,0,0,1,69.075,8.06L63.3,13.83a4.32,4.32,0,0,1-7.153-1.691l2.731-2.731a1.946,1.946,0,0,1,3.178.643.344.344,0,0,0,.638-.258,2.634,2.634,0,0,0-4.3-.871l-2.813,2.813a.343.343,0,0,0-.121.121l-2.837,2.837a2.634,2.634,0,0,0,3.725,3.725L58.169,16.6a.344.344,0,1,0-.487-.487L55.863,17.93a1.946,1.946,0,1,1-2.751-2.751l2.5-2.5a5.008,5.008,0,0,0,8.175,1.643l5.771-5.771a5.013,5.013,0,0,0,0-7.082Z",
    transform: "translate(-49.313 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.f984f2c85c4335bc4f9cfeecb627c7d9.svg";
export { ForwardRef as ReactComponent };